import React from 'react';
import * as styles from './SettingsSection.module.scss';

interface SettingsSectionProps {
  children: React.ReactNode;
  header?: React.ReactNode;
  subheader?: React.ReactNode;
}

const SettingsSection = ({
  children,
  header,
  subheader,
}: SettingsSectionProps) => (
  <div className={styles.section}>
    {!!header && (
      <div className={styles.header}>
        <h4>{header}</h4>
        {!!subheader && <div>{subheader}</div>}
      </div>
    )}
    {children}
  </div>
);

export default SettingsSection;
